import { render } from "./YNDialogue.vue?vue&type=template&id=5288f53c"
import script from "./YNDialogue.vue?vue&type=script&lang=js"
export * from "./YNDialogue.vue?vue&type=script&lang=js"

import exportComponent from "/Users/callum/Dev/saxton/saxton-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__